<template>
  <div class="about text-center">
    <div class="contact" @click="gotoContact">Contact Us</div>
    <!-- <div class="v-line">|</div>
    <div class="Join" @click="gotoJoin">Join Us</div> -->
    <div class="v-line">|</div>
    <div class="aboutus" @click="gotoAbout">About Us</div>
  </div>
</template>

<script>
export default {
  name: "About",
  methods:{
    gotoJoin(){
      this.$router.push('/joinus')
    },
    gotoAbout(){
      this.$router.push('/aboutus')
    },
    gotoContact(){
      this.$router.push('/contact')
    }
  }
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
  .about {
    display: flex;
    margin-top: 1.6rem;
    width: 100%;
    font-size: 14px;
    margin-bottom:.15rem;
    color: #867EAD !important;
    opacity: .7;
    // margin-left: 25px;
    padding: 0 25px;
    justify-content: center;
    box-sizing: border-box;
    div {
      cursor: pointer;
      padding: 0 0.1rem;
    }
    .contact {
      padding: 0;
      // margin-left: .2rem;
    }
    .v-line {
      color: #b1b1b1ff;
    }
  }
}
@media screen and (min-width: 768px) {
  .about {
    display: flex;
    width: 100%;
    font-size: 14px;
    margin-top: .5rem;
    color: #867EAD !important;
    justify-content: center;
    div {
      cursor: pointer;
      padding: 0 0.1rem;
    }
    .contact {
      // margin-left: .1rem;
    }
    .v-line {
      color: #b1b1b1ff;
    }
  }
}
</style>